import React from "react";
import PropTypes from "prop-types";
import {
  LinkedAccountingSoftwareButton,
  ManualInvoicesToggleButton,
  SyncInvoicesButton
} from "./SyncInvoicesButton";

const FundActionButtons = ({
  buttons,
  onManual,
  onSync,
  syncLoading,
  xeroInvoiceJobId
}) => {
  return (
    <div className="fund-btn-group if-manual-upload-preferred mb-5 if-manual-upload-preferred-main row">
      {buttons.includes("MANUAL") && (
        <ManualInvoicesToggleButton toggleManualModal={onManual} />
      )}
      {buttons.includes("SYNC") && (
        <SyncInvoicesButton
          handleSyncInvoices={onSync}
          showLoadingButton={syncLoading}
          xeroInvoiceJobId={xeroInvoiceJobId}
        />
      )}
      {buttons.includes("LINK") && <LinkedAccountingSoftwareButton />}
    </div>
  );
};

FundActionButtons.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.oneOf(["MANUAL", "SYNC", "LINK"]))
    .isRequired,
  onManual: PropTypes.func.isRequired,
  onSync: PropTypes.func.isRequired,
  syncLoading: PropTypes.bool,
  xeroInvoiceJobId: PropTypes.string
};

FundActionButtons.defaultProps = {
  syncLoading: false,
  xeroInvoiceJobId: null
};

export default FundActionButtons;
